<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popCode"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranCode"
        :options="colFilter.tran_code_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popMerchant"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranMerchant"
        :options="colFilter.tran_merchant_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">View Generated Codes</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Info Section -->
    <div class="section" v-if="!isEmpty">
      <div class="row">
        <div class="col-md-6">
          <label class="mb-0">Merchant Name</label><br />
          <h4>{{ merchant }}</h4>
        </div>
        <div class="col-md-6">
          <label class="mb-0">Created Date</label><br />
          <h4>{{ createdDate }}</h4>
        </div>
      </div>
    </div>
    <!-- /Info Section -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popCode
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranCode.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('code')">
                    Code
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'code'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'code_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>Remarks</th>
                <th>
                  <button class="btn p-0" @click="setSortBy('issuedDate')">
                    Issued Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'issuedDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'issuedDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('redeemedDate')">
                    Redeemed Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'redeemedDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'redeemedDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popMerchant
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranMerchant.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('merchant')">
                    Redeemed by Merchant
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'merchant'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'merchant_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rec, i) in records" :key="i">
                <td>{{ rec.code }}</td>
                <td>{{ rec.remarks }}</td>
                <td>{{ rec.generated_date_display }}</td>
                <td>{{ rec.redeemed_date_display }}</td>
                <td>{{ rec.redeemed_by_merchant }}</td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="5" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Back Button -->
    <div class="row mt-4 text-center">
      <div class="col-md-12">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fa fa-reply mr-2"></i>Back to Flexible E-Coupons
        </button>
      </div>
    </div>
    <!-- /Back Button -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      records: [],
      merchant: "",
      createdDate: "",
      isEmpty: false,
      //pagination
      searchColFilter: {
        tranCode: [],
        tranMerchant: [],
      },
      colFilter: {},
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    searchFilter() {
      return [
        { name: "tranCode", val: this.searchColFilter.tranCode },
        { name: "tranMerchant", val: this.searchColFilter.tranMerchant },
      ];
    },
  },
  watch: {
    "searchColFilter.tranCode": function (val, oldVal) {
      this.getFlexibleEcouponDetails();
    },
    "searchColFilter.tranMerchant": function (val, oldVal) {
      this.getFlexibleEcouponDetails();
    },
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getFlexibleEcouponDetails();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getFlexibleEcouponDetails() {
      let param = {
        id: this.$route.params.id,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
        search_filter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getFlexibleEcouponDetails(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (!response.data.is_empty) {
              this.records = response.data.records;
              this.merchant = response.data.merchant;
              this.createdDate = response.data.created_date;
              this.totalRecords = response.data.total;
              this.paging.TotalPage = response.data.page_count;
              this.colFilter = response.data.col_filter;
              if (this.paging.CurrentPage > this.paging.TotalPage) {
                this.paging.CurrentPage = 1;
              }
            } else {
              this.isEmpty = true;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getFlexibleEcouponDetails();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getFlexibleEcouponDetails();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getFlexibleEcouponDetails();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getFlexibleEcouponDetails();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getFlexibleEcouponDetails();
    },
    setSortBy(payload) {
      switch (payload) {
        case "code":
          if (this.paging.SortBy === "code") {
            this.paging.SortBy = "code_desc";
          } else if (this.paging.SortBy === "code_desc") {
            this.paging.SortBy = "code";
          } else {
            this.paging.SortBy = "code";
          }
          break;
        case "issuedDate":
          if (this.paging.SortBy === "issuedDate") {
            this.paging.SortBy = "issuedDate_desc";
          } else if (this.paging.SortBy === "issuedDate_desc") {
            this.paging.SortBy = "issuedDate";
          } else {
            this.paging.SortBy = "issuedDate";
          }
          break;
        case "redeemedDate":
          if (this.paging.SortBy === "redeemedDate") {
            this.paging.SortBy = "redeemedDate_desc";
          } else if (this.paging.SortBy === "redeemedDate_desc") {
            this.paging.SortBy = "redeemedDate";
          } else {
            this.paging.SortBy = "redeemedDate";
          }
          break;
        case "merchant":
          if (this.paging.SortBy === "merchant") {
            this.paging.SortBy = "merchant_desc";
          } else if (this.paging.SortBy === "merchant_desc") {
            this.paging.SortBy = "merchant";
          } else {
            this.paging.SortBy = "merchant";
          }
          break;
      }
      this.getFlexibleEcouponDetails();
    },
  },
  created() {
    this.getFlexibleEcouponDetails();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Share/FlexibleEcouponDetail.vue